import { NetworkType } from '@layerswap/widget-types';
import KnownInternalNames from "../../knownIds";
import { AddressSelectionMode } from "../../types";
export const name = 'Fuel';
export class FuelAddressUtilsProvider {
    constructor() {
        this.providerName = name;
        this.networkType = NetworkType.Fuel;
        this.label = 'Fuel';
        this.selection = AddressSelectionMode.Auto;
    }
    supportsNetwork(network) {
        return (KnownInternalNames.Networks.FuelMainnet.includes(network.name) || KnownInternalNames.Networks.FuelTestnet.includes(network.name));
    }
    isValidAddress(props) {
        const { address } = props;
        if (!address) {
            return false;
        }
        const hexRegex = /^[0-9a-fA-F]+$/;
        let addr = address;
        if (addr.startsWith("0x")) {
            addr = addr.slice(2); // Remove the "0x" prefix
        }
        else {
            return false;
        }
        return addr.length === 64 && hexRegex.test(addr);
    }
}
